import React, { useCallback } from 'react';
import styled from 'styled-components';
import { GiftHistoryResponse } from '../api';
import { useDonee } from '../../../../../../providers/DoneeProvider';
import GivelifyBanner from '../../../common/GivelifyBanner';
import { ErrorInfoIcon } from '../../../../../icons';
import { GivelifyButton } from '../../../common/Button/GivelifyButton';
import { DonationsQueryParams } from '../../../CheckoutWizard/utils';
import { setDonationDetails } from '../../../CheckoutWizard';
import { useNavigate } from 'react-router-dom';

export type GiftHistoryDetail = GiftHistoryResponse['data'][number] & {
  detailType: 'history';
};

interface GiftFailedBannerProps {
  detail: GiftHistoryDetail;
}

const StyledDiv = styled.div`
  .submit-button {
    margin-bottom: 24px;
  }
`;

const GiftFailedBanner: React.FC<GiftFailedBannerProps> = ({ detail }) => {
  const push = useNavigate();
  const { doneeId } = useDonee();

  const handleRetry = useCallback(() => {
    if (!doneeId) return;
    const d: DonationsQueryParams[] = detail.envelopes.map((e) => ({
      envelopeId: e.id,
      amount: e.amount
    }));
    push(setDonationDetails(doneeId, d));
  }, [doneeId]);

  return (
    <StyledDiv>
      <GivelifyBanner
        marginBottom="16px"
        icon={<ErrorInfoIcon color="utilityError" />}
        borderColor="utilityError"
        backgroundColor="utilityErrorLightColor"
        header="Gift Failed"
        body="We weren't able to charge your card"
      />
      <GivelifyButton
        onClick={handleRetry}
        className="submit-button"
      >
        Try Gift Again
      </GivelifyButton>
    </StyledDiv>
  );
};

export default GiftFailedBanner;
